<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4 class="vue-title">
          <strong>ユーザ ＞ 作成</strong>
        </h4>

        <br />
        <b-form class="formTextSize">
          <b-row>
            <b-col sm="1">
              <b-form-group id="addressField" label-for="input-1">
                <span>{{ $t("ID") }}</span>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <span>
                <b-form-input
                  class="inputField"
                  v-model.trim="$v.createPartner.user_id.$model"
                  type="text"
                  autocomplete="name"
                  readonly
                ></b-form-input>
              </span>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col sm="3">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("SURNAME") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  id="last_name"
                  v-model.trim="$v.createPartner.last_name.$model"
                  class="inputField"
                  type="text"
                  autocomplete="name"
                  readonly
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("NAME") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  id="name"
                  v-model.trim="$v.createPartner.first_name.$model"
                  class="inputField"
                  type="text"
                  autocomplete="name"
                  readonly
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col sm="3">
              <b-form-group id="addressField" label-for="input-1">
                <span> {{ $t("SURNAME") }} ( {{ $t("HIRAGANA") }}) </span>
                <b-form-input
                  id="furigana_last_name"
                  v-model.trim="$v.createPartner.furigana_last_name.$model"
                  class="inputField"
                  type="text"
                  autocomplete="name"
                  readonly
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col sm="3">
              <b-form-group id="addressField" label-for="input-1">
                <span> {{ $t("NAME") }} ( {{ $t("HIRAGANA") }}) </span>
                <b-form-input
                  id="furigana_first_name"
                  v-model.trim="$v.createPartner.furigana_first_name.$model"
                  class="inputField"
                  type="text"
                  autocomplete="name"
                  readonly
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="3">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("BIRTHDATE") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  id="date_of_birth"
                  v-model.trim="$v.createPartner.date_of_birth.$model"
                  class="inputField"
                  type="text"
                  autocomplete="name"
                  readonly
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col sm="3">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("EMAIL") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  id="email"
                  v-model.trim="$v.createPartner.email.$model"
                  class="inputField"
                  type="text"
                  autocomplete="name"
                  readonly
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("PHONENUMBER") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  @keypress="isNumberValidator($event)"
                  id="contact_no"
                  v-model.trim="$v.createPartner.contact_no.$model"
                  class="inputField"
                  type="text"
                  autocomplete="name"
                  :maxlength="max"
                  readonly
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("BUILDINGNAME") }}
                </span>
                <b-form-input
                  id="building_name"
                  v-model.trim="$v.createPartner.building_name.$model"
                  class="inputField"
                  type="text"
                  autocomplete="name"
                  readonly
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row></b-row>
          <br />
          <b-row>
            <b-col sm="3">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("STREETADDRESS") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  id="street_address"
                  v-model.trim="$v.createPartner.street_address.$model"
                  class="inputField"
                  type="text"
                  autocomplete="name"
                  readonly
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col sm="3">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("PREFECTURES") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  id="prefecture"
                  v-model.trim="$v.createPartner.prefecture.$model"
                  class="inputField"
                  type="text"
                  autocomplete="name"
                  readonly
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("POSTALCODE") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  v-model.trim="$v.createPartner.postal_code.$model"
                  @keypress="isNumberValidator($event)"
                  class="inputField"
                  type="text"
                  autocomplete="name"
                  readonly
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col sm="3">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("CITY") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  id="city"
                  v-model.trim="$v.createPartner.city.$model"
                  class="inputField"
                  type="text"
                  autocomplete="name"
                  readonly
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="3">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("GENDER") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  id="gender"
                  v-model.trim="$v.createPartner.gender.$model"
                  class="inputField"
                  type="text"
                  autocomplete="name"
                  readonly
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
        <br />
        <br />
        <b-form>
          <b-row>
            <b-col sm="4">
              <strong>提供サービス</strong>
            </b-col>
          </b-row>
          <hr />
          <!-- service list -->
          <table>
          <th scope="col"></th>                       
                 <th scope="col"></th>
            <tr
              v-for="item in this.createPartner.services"
              v-bind:key="item.id"
            >
              <td>
                <b-form-checkbox disabled checked="true"></b-form-checkbox>
             
              </td>
              <td class="custom-tdClass">
                <strong>
                  <b-form-text disabled :value="item.id">
                    {{ item.name }}
                  </b-form-text>
                </strong>
              </td>
            </tr>
          </table>

          <b-row>
            <b-col md="12" class="text-center">
              <b-button
            class="btn btn-secondary  formTextSizeBlack mr-2"
            to="/createuser"
            >{{ $t("CANCEL") }}</b-button
          >
              <button
                class="btn btn-primary formTextSizeBlack"
                @click="success"
              >
                {{ $t("ADDTO") }}
              </button>
               
            </b-col>
          </b-row>
        </b-form>
        <br />

        <br />
      </div>
    </div>
  </div>
</template>

<script>
import { required, email, minLength ,numeric } from "vuelidate/lib/validators";
import { REGISTER_PATIENT, PARTNER_MAPPING } from "@/store/actions.type";
import { isNumberValidator } from "@/shared/utils.js";

export default {
  name: "add-partner",
  components: {
  },

  data: function() {
    return {
      max: 10,
      isNumberValidator: isNumberValidator,
       CONSTANTS: null,
      createPartner: {
        email: "",
        gender: "male",
        date_of_birth: "",
        furigana_last_name: "",
        first_name: "",
        last_name: "",
        furigana_first_name: "",
        contact_no: "",
        building_name: "",
        street_address: "",
        prefecture: "",
        city: "",
        postal_code: "",
        service_ids: "",
        user_id: ""
      },
      userId:'',

      services: []
    };
  },
  validations: {
    createPartner: {
      email: { required, email },
      gender: { required },
      date_of_birth: { required },
      furigana_last_name: { required },
      first_name: { required },
      last_name: { required },
      furigana_first_name: { required },
      contact_no: {required,phoneNumber:minLength(10) , numeric },
      building_name: {},
      street_address: { required },
      prefecture: { required },
      city: { required },
      postal_code: { required },
      service_ids: { required },
      user_id: { required }
    }
  },

  methods: {
    success() {
      this.isLoading = this.$loading.show({
        loader: "dots",
        color: "#007bff"
      });

      this.$store
        .dispatch(PARTNER_MAPPING, {user_id: this.userId})
        .then(data => {
          this.isLoading.hide();
          if (data.status) {
            this.$toast.success({
              message: data.message
            });
            this.$router.push({
              name: "user"
            });
          } else {
            this.$toast.error({
              message: data.message
            });
          }
        });
    }
  },
  created() {
    this.$toast.removeAll();
    this.params = this.$route.params;
    if (_.get(this.params, "id", 0)) {
      this.isLoading = this.$loading.show({ loader: "dots", color: "#007bff" });

      this.$store
        .dispatch(REGISTER_PATIENT, {
          userid: _.get(this.params, "id", 0),
          dob: _.get(this.params, "dob", 0)
        })
        .then(data => {
          this.isLoading.hide();
          console.log("data", data);
          let fname = _.get(data, "searchResult.first_name", "");
          console.log("fname", fname);
          if (_.get(data, "status", 0)) {
            // let serviceList = _.filter(
            //   _.get(data, "searchResult.services", []),
            //   item => item != null || item != undefined
            // );
            let list = [];

            $.each(data.searchResult.services, function(key, value) {
              list[key] = value.id;
            });
            this.userId =   _.get(data, "searchResult.user_id", "");
            this.createPartner = {
              service_ids: list,
              user_id: _.get(this.params, "id", 0),
              first_name: _.get(data, "searchResult.first_name", ""),
              last_name: _.get(data, "searchResult.last_name", ""),
              gender: _.get(data, "searchResult.gender", "") == "male" ? "男性": _.get(data, "searchResult.gender", "") == "female" ? '女性' : 'その他',
              email: _.get(data, "searchResult.email", ""),
              furigana_last_name: _.get(
                data,
                "searchResult.furigana_first_name",
                ""
              ),
              furigana_first_name: _.get(
                data,
                "searchResult.furigana_last_name",
                ""
              ),
              date_of_birth: _.get(data, "searchResult.date_of_birth", ""),
              building_name: _.get(
                data,
                "searchResult.address.building_name",
                ""
              ),
              street_address: _.get(
                data,
                "searchResult.address.street_address",
                ""
              ),
              prefecture: _.get(data, "searchResult.address.prefecture", ""),
              city: _.get(data, "searchResult.address.city", ""),
              postal_code: _.get(data, "searchResult.address.postal_code", ""),
              contact_no: _.get(data, "searchResult.contact_no", ""),
              services: _.get(data, "searchResult.services", "")
            };
            this.services = list;

            console.log("this.createPartner2", this.createPartner);
          }
        })
        .catch(e => {
          console.log("error", e.message);
        });
    }
  }
};
</script>
<style>
.dragArea {
  min-height: 100px;
  background: #ededed;
  padding: 10px;
}
.list-group-item {
  margin-bottom: 6px;
}
.custom-tdClass{
  padding:5px 10px;

}
</style>
